module.exports = __webpack_public_path__ + "img/gsb35.d18c68c3.png";